<template>
  <div class="partner-bd cert-bd">
    <div class="cert-item">
      <div class="title">{{ $t('crm_partner-cert.zheng_shu_xin_xi') }}</div>
      <div class="row">
        <p class="col">
          <span class="key">{{ $t('crm_partner-cert.zheng_shu_ming_cheng') }}：</span>
          <span class="val">{{ $t('crm_partner-cert.qysmzs') }}</span>
        </p>
        <p class="col">
          <span class="key">{{ $t('crm_partner-cert.zsxlbh') }}：</span>
          <span class="val">{{ info.certId }}</span>
        </p>
        <p class="col">
          <span class="key">{{ $t('crm_partner-cert.you_xiao_qi') }}：</span>
          <span class="val">{{ info.stopTime }}</span>
        </p>
        <p class="col">
          <span class="key">{{ $t('crm_partner-cert.qian_ding_ri_qi') }}：</span>
          <span class="val">{{ momentAmPm($momentLocal(info.startTime, 'YYYY-MM-DD')) }}</span>
        </p>
      </div>
      <div class="row">
        <p class="col">
          <span class="key">{{ $t('crm_partner-cert.qi_ye_ming_cheng') }}：</span>
          <span class="val">{{ data.partnerName }}</span>
        </p>
        <p class="col">
          <span class="key">{{ $t('crm_partner-cert.tyshxydm') }}：</span>
          <span class="val">{{ data.businessLicense }}</span>
        </p>
        <p class="col">
          <span class="key">{{ $t('crm_partner-cert.fddbrxm') }}：</span>
          <span class="val">{{ data.legalPerson }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
// import waitdevice from './waitdevice.vue';

export default {
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      info: {},
    };
  },
  mounted() {
    this.getCertInfo();
  },
  methods: {
    // 获取我的设备列表
    getCertInfo: function () {
      this.$getJSON(apis.bestsginUserCertInfo, {
        account: this.data.businessLicense,
        certId: this.data.certNo,
        // account: '91330106311313186013',
        // certId: 'ZJCA-11-20200811160406710-00004'
      }).then((res) => {
        this.info = res.data || {};
      });
    },
  },
};
</script>

<style lang="scss">
.partner-bd {
  padding-left: 40px;
  padding-right: 24px;
  .cert-item {
    font-size: 12px;
    padding-bottom: 32px;
    // border-bottom: 1px solid #eef2f8;

    &:nth-child(n + 2) {
      margin-top: 7px;
    }

    overflow: hidden;
    .title {
      color: #0d9ae0;
      font-weight: bold;
      line-height: 16px;
      margin: 24px 0 12px;
    }
    .row {
      overflow: hidden;
      border-top: 1px solid #eef2f8;
      padding: 12px 0;
      .col {
        float: left;
        width: 100%;
        height: 26px;
        font-size: 12px;
        line-height: 26px;
        overflow: hidden;
        .key {
          color: #6c757d;
          line-height: 26px;
          width: 150px;
          display: inline-block;
        }
        .val {
          line-height: 26px;
          color: #394668;
        }
        .detail {
          color: #0d9ae0;
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }

    .table-bd {
      margin-top: 24px;
    }
  }
}
</style>
